import { render, staticRenderFns } from "./alert-box.vue?vue&type=template&id=0dd8b20c&scoped=true&"
import script from "./alert-box.vue?vue&type=script&lang=js&"
export * from "./alert-box.vue?vue&type=script&lang=js&"
import style0 from "./alert-box.vue?vue&type=style&index=0&id=0dd8b20c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd8b20c",
  null
  
)

export default component.exports